import React, { useCallback, useEffect, useState } from "react";
import profileImage from "../../../assets/imgs/dummy-img.png";
import "../../passenger/passenger.css";
import { Avatar } from "primereact/avatar";
import { Rating } from "primereact/rating";
import { Button } from "primereact/button";
import GoogleMapComp from "./Googlemap";
import { useLocation } from "react-router-dom";
import { Timeline } from "primereact/timeline";
import moment from "moment";
import { handleEncryptData } from "../../../services/EncryptionService";
import { handleDecryptData } from "../../../services/DecryptionService";
import { getSocket, SOCKET_ENDPOINTS } from "../../../services/Socket";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { handlePostRequest } from "../../../services/PostTemplate";
import axios from "axios";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { handleGetRequest } from "../../../services/GetTemplate";
import { InputTextarea } from "primereact/inputtextarea";
import { confirmDialog } from "primereact/confirmdialog";
import { ConfirmDialog } from "primereact/confirmdialog";

const DriverRide = () => {
    const [mapLoaded, setMapLoaded] = useState(false);
    const [startPosition, setStartPosition] = useState(null); // Initially null to wait for user location
    const [endPosition, setEndPosition] = useState(null);
    const [directions, setDirections] = useState(null);
    const [pessangerData, setPessangerData] = useState(null);
    const [matchedPassengers, setmatchedPassengers] = useState(null);
    const [currentStatus, setCurrentStatus] = useState("On the way"); // Initial status
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.authenticationSlice?.userId) || localStorage.getItem("userId");

    const location = useLocation();
    const decryptedResponse = location.state?.data;
    const routeId = "678fad44ce7b08df6fa971fb";

    const socket = getSocket();
    const history = useHistory();

    const [showCancelDialog, setShowCancelDialog] = useState(false);
    const [reasons, setReasons] = useState([]);
    const [selectedReason, setSelectedReason] = useState(null);
    const [currentPassengerId, setCurrentPassengerId] = useState(null);
    const [customReason, setCustomReason] = useState("");

    console.log(selectedReason, "selectedReason");

    const fetchReasons = async () => {
        try {
            console.log("Fetching reasons...");
            const response = await dispatch(handleGetRequest(`api/reasons/getAll`, true, true));
            console.log("Reasons fetched:", response?.data);
            console.log("Reasons fetched:", response?.data);
            setReasons(response?.data);
        } catch (error) {
            console.error("Error fetching reasons:", error);
        }
    };

    const handleCancelClick = async (passengerId) => {
        setShowCancelDialog(true);
        setCurrentPassengerId(passengerId);
        await fetchReasons();
    };

    const handleConfirmCancel = () => {
        if (selectedReason && currentPassengerId) {
            const reasonText = selectedReason.name === "Other" ? customReason : selectedReason.name;
            handleEmergencyCancel(currentPassengerId, selectedReason._id, reasonText);
            setShowCancelDialog(false);
        } else {
            toast.error("Please select a reason for cancellation.");
        }
    };

    const handleEmergencyCancel = (passengerId, reasonId, reasonText) => {
        if (!passengerId) {
            console.error("Route ID or User ID is missing!");
            return;
        }
        const encryptedData = {
            rideId: decryptedResponse?.activeRide?._id,
            passengerId: passengerId,
            completeRideReasonId: reasonId,
            completeRideReasonText: reasonText,
        };
        console.log("encryptedData", encryptedData);
        const encryptData = handleEncryptData(encryptedData);
        console.log(encryptData, "encryptedData");
        // Emit the socket event emergencyCancelByDriver
        socket.emit("emergencyCancelByDriver", JSON.stringify(encryptData), (response) => {
            const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
            console.log(decryptedResponse, "decryptedResponse Start");
            if (decryptedResponse.status === true) {
                toast.success("Ride Cancelled Successfully");
                history.push("/schedules");
            }
        });
    };

    console.log("Received Data:", routeId);
    console.log("matchedPassengers Data:", decryptedResponse);

    useEffect(() => {
        const handleStartRoute = (routeId) => {
            if (!routeId || !userId) {
                console.error("Route ID or User ID is missing!");
                return;
            }
            const encryptedData = {
                routeId: "678fad44ce7b08df6fa971fb",
                userId: userId,
            };
            const encryptData = handleEncryptData(encryptedData);
            // Emit the socket event
            socket.emit("start", JSON.stringify(encryptData), (response) => {
                const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
                console.log(decryptedResponse, "decryptedResponse Start");

                if (!decryptedResponse?.activeRide && (!decryptedResponse?.pendingList || decryptedResponse?.pendingList.length == 0)) {
                    console.log("No record");
                } else {
                    // Redirect to driver-ride with data
                    history.push({
                        pathname: "/driver-ride",
                        state: { data: decryptedResponse },
                    });
                }
                socket.on("autoCompletedRoute", (data) => {
                    console.log(data);
                });
            });
        };
        handleStartRoute(routeId);
    }, []);

    useEffect(() => {
        setPessangerData(decryptedResponse?.activeRide?.passengers);
        setmatchedPassengers(decryptedResponse);
    }, [decryptedResponse]);

    console.log("pessangerData", pessangerData);

    useEffect(() => {
        const liveLocation = async () => {
            try {
                const payload = {
                    userId: userId,
                    routeId: "678fad44ce7b08df6fa971fb",
                    location: {
                        endPoint: {
                            latitude: 31.5203696,
                            longitude: 74.35874729999999,
                        },
                    },
                };
                const encryptData = handleEncryptData(payload);
                // Sending the payload in the body of the POST request
                const response = await axios.post(`${process.env.REACT_APP_BASE_URL_BACKEND}api/route/livelocation`, encryptData);

                console.log(response?.data, ".response");

                // Decrypt the response data
                const decryptedResponse = handleDecryptData(response?.data?.cipher); // Ensure you have a decrypt utility
                console.log(decryptedResponse);
            } catch (error) {
                console.error(error);
            }
        };

        liveLocation();
    }, []);

    useEffect(() => {
        console.log("call");
        const timeoutId = setTimeout(() => {
            socket.emit("refreshLiveLocation", {}, (data) => {
                try {
                    const decryptedResponse = handleDecryptData(data?.cipher);
                    console.log(decryptedResponse, "decryptedResponse newRequest");
                } catch (error) {
                    console.error("Error while decrypting data:", error);
                }
            });
        }, 0); // Trigger immediately (or adjust timing if necessary)

        // Cleanup timeout
        return () => clearTimeout(timeoutId);
    }, [socket]);

    useEffect(() => {
        // Emit an event to request live location updates

        // Listen for the "refreshLiveLocation" event
        socket.on(SOCKET_ENDPOINTS.REFRESH_LIVE_LOCATION, (data) => {
            const decryptedData = handleDecryptData(data?.cipher); // Decrypt the received data
            console.log("Live Location Update:", decryptedData);

            if (decryptedData?.location) {
                setStartPosition({
                    lat: decryptedData.location.latitude,
                    lng: decryptedData.location.longitude,
                });
            }
        });

        // Cleanup on component unmount
    }, []);

    useEffect(() => {
        socket.on(SOCKET_ENDPOINTS.ERROR, (error) => {
            toast.error(`Socket Error: ${error.msg}`);
            console.log(error.msg, "error");
        });

        return () => {
            socket.off(SOCKET_ENDPOINTS.ERROR);
        };
    }, [socket]);

    const handleMapLoaded = useCallback(() => {
        setMapLoaded(true);
        if (startPosition) fetchDirections();
    });
    const fetchDirections = () => {
        if (!startPosition) return;
        const directionsService = new window.google.maps.DirectionsService();
        directionsService.route(
            {
                origin: startPosition,
                destination: endPosition,
                travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
                if (status === window.google.maps.DirectionsStatus.OK) {
                    setDirections(result);
                    console.log("Directions fetched successfully:", result);
                } else {
                    console.error("Error fetching directions:", status);
                }
            }
        );
    };

    useEffect(() => {
        if (decryptedResponse?.activeRide) {
            const { startPoint, endPoint } = decryptedResponse?.activeRide?.routeId;

            // Check and set start position if valid
            if (startPoint?.latitude && startPoint?.longitude) {
                setStartPosition({
                    lat: startPoint.latitude,
                    lng: startPoint.longitude,
                });
            } else {
                console.warn("Start point is null or incomplete");
            }

            // Check and set end position if valid
            if (endPoint?.latitude && endPoint?.longitude) {
                setEndPosition({
                    lat: endPoint.latitude,
                    lng: endPoint.longitude,
                });
            } else {
                console.warn("End point is null or incomplete");
            }
        } else {
            console.warn("matchedPassengers.data is null or undefined");
        }
    }, [matchedPassengers?.data]);

    const userMarkers = pessangerData?.map((passenger) => ({
        position: {
            lat: passenger?.passenger?.startPoint?.latitude,
            lng: passenger?.passenger?.startPoint?.longitude,
        },
        title: passenger?.passenger?.userId?.firstName || "Unknown User",
        icon: "http://maps.google.com/mapfiles/ms/icons/red-dot.png", // Optional: Customize the icon for each user
    }));

    /////////////////////  Sockets  /////////////////////
    const onTheWay = (passengerId) => {
        if (!passengerId) {
            console.error("Route ID or User ID is missing!");
            return;
        }
        const encryptedData = {
            rideId: decryptedResponse?.activeRide?._id,
            passengerId: passengerId,
        };
        const encryptData = handleEncryptData(encryptedData);
        console.log(encryptData, "encryptedData");
        // Emit the socket event
        socket.emit("onTheWay", JSON.stringify(encryptData), (response) => {
            const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
            console.log(decryptedResponse, "decryptedResponse Start");
            // Cycle through statuses: pending -> active -> arrived
            if (decryptedResponse?.passengers && Array.isArray(decryptedResponse.passengers)) {
                // Find the passenger with the given passengerId
                const passenger = decryptedResponse.passengers.find((p) => p.passenger._id === passengerId);
                if (passenger) {
                    const passengerStatus = passenger.status;
                    if (passengerStatus === "pending") {
                        setCurrentStatus("On the way");
                    } else if (passengerStatus === "active") {
                        setCurrentStatus("Arrived");
                    } else if (passengerStatus === "arrived") {
                        setCurrentStatus("Cancel");
                    }
                }
            }
            // window.location.reload()
        });
    };

    const cancelReqPessanger = (passengerId) => {
        console.log("cancelReqPessanger called with passengerId:", passengerId);
        confirmDialog({
            message: "Do you want to Cancel this Route?",
            header: "Cancel Confirmation",
            icon: "pi pi-info-circle",
            rejectClassName: "custom-reject-btn",
            reject: () => console.log("cancel"),
            accept: () => handleCancelRoute(passengerId),
        });
    };

    const handleCancelRoute = (passengerId) => {
        if (!passengerId) {
            console.error("Route ID or User ID is missing!");
            return;
        }
        const encryptedData = {
            rideId: decryptedResponse?.activeRide?._id,
            passengerId: passengerId,
            reason: "reason",
        };
        const encryptData = handleEncryptData(encryptedData);
        console.log(encryptedData, "encryptedData");
        // Emit the socket event emergencyCancelByDriver
        socket.emit("cancelInRidePassengerRequestByDriver", JSON.stringify(encryptData), (response) => {
            const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
            console.log(decryptedResponse, "decryptedResponse Start");
            if (decryptedResponse.status === true) {
                toast.success("Ride Cancel Successfully");
                history.push("/schedules");
            }
        });
    };

    const handlearrived = (passengerId) => {
        if (!passengerId) {
            console.error("Route ID or User ID is missing!");
            return;
        }
        const encryptedData = {
            rideId: decryptedResponse?.activeRide?._id,
            passengerId: passengerId,
            // reason: "resaon",
        };
        console.log(encryptedData);
        const encryptData = handleEncryptData(encryptedData);
        console.log(encryptData, "encryptedData");
        // Emit the socket event
        socket.emit("arrived", JSON.stringify(encryptData), (response) => {
            const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
            console.log(decryptedResponse, "decryptedResponse Start");
            // window.location.reload()
        });
    };

    // const handleStartRoute = (passengerId) => {
    //     if (!passengerId) {
    //         console.error("Route ID or User ID is missing!");
    //         return;
    //     }
    //     const encryptedData = {
    //         rideId: decryptedResponse?.activeRide?._id,
    //         passengerId: passengerId,
    //     };
    //     const encryptData = handleEncryptData(encryptedData);
    //     console.log(encryptData, "encryptedData");
    //     // Emit the socket event
    //     // socket.emit("startRide", JSON.stringify(encryptedData), (response) => {
    //     //     const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
    //     //     console.log(decryptedResponse, "decryptedResponse Start");
    //     // });
    // };

    // const handleCompleteRoute = (passengerId) => {
    //     if (!passengerId) {
    //         console.error("Route ID or User ID is missing!");
    //         return;
    //     }
    //     const encryptedData = {
    //         rideId: decryptedResponse?.activeRide?._id,
    //         passengerId: passengerId,
    //     };
    //     const encryptData = handleEncryptData(encryptedData);
    //     console.log(encryptData, "encryptedData");
    //     // Emit the socket event
    //     // socket.emit("pendingPayment", JSON.stringify(encryptedData), (response) => {
    //     //     const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
    //     //     console.log(decryptedResponse, "decryptedResponse Start");
    //     // });
    // };
    const handleFinishRoute = (passengerId) => {
        if (!passengerId) {
            console.error("Route ID or User ID is missing!");
            return;
        }
        const encryptedData = {
            rideId: decryptedResponse?.activeRide?._id,
            passengerId: passengerId,
        };
        const encryptData = handleEncryptData(encryptedData);
        console.log(encryptData, "encryptedData");
        // Emit the socket event
        // socket.emit("pendingPayment", JSON.stringify(encryptedData), (response) => {
        //     const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
        //     console.log(decryptedResponse, "decryptedResponse Start");
        // });
    };

    // if (pessangerData?.length === 0) {
    //     return <h4>No passenger </h4>;
    // }

    const handleReasonChange = (e) => {
        console.log("Selected reason:", e.value);
        setSelectedReason(e.value);
    };

    return (
        <>
            <div style={{ margin: "0 auto", maxWidth: "80vw", height: "70vh" }}>
                <GoogleMapComp
                    directions={directions}
                    mapLoading={handleMapLoaded}
                    startPosition={startPosition}
                    endPosition={endPosition}
                    userMarkers={userMarkers} // Pass user markers array
                />
            </div>

            <Dialog header="Cancel Ride" visible={showCancelDialog} onHide={() => setShowCancelDialog(false)} style={{ backgroundColor: "blue", minWidth: "35%" }}>
                <div className="field flex flex-column">
                    <label htmlFor="reason" style={{ color: "white" }}>
                        Select Reason
                    </label>
                    <Dropdown
                        id="reason"
                        value={selectedReason}
                        options={reasons}
                        onChange={handleReasonChange}
                        optionLabel="name" // Display the name field in the dropdown
                        placeholder="Select a reason"
                        style={{ color: "black", width: "100%" }} // Change text color to black
                    />
                    {selectedReason?.name === "Other" && (
                        <div className="field mt-3">
                            <label htmlFor="customReason" style={{ color: "white" }}>
                                Enter Reason
                            </label>
                            <InputTextarea id="customReason" value={customReason} onChange={(e) => setCustomReason(e.target.value)} rows={3} style={{ width: "100%" }} />
                        </div>
                    )}
                </div>
                <div className="flex justify-content-around">
                    <Button label="Cancel" icon="pi pi-times" onClick={() => setShowCancelDialog(false)} className="p-button-text" style={{ color: "white" }} />
                    <Button label="Confirm" icon="pi pi-check" onClick={handleConfirmCancel} autoFocus />
                </div>
            </Dialog>

            <ConfirmDialog />

            <div>
                {pessangerData?.length === 0 ? (
                    <>
                        <h4 style={{ display: "flex", justifyContent: "center", color: "#d1352a", marginTop: "30px", fontWeight: "bolder" }}>No passenger match</h4>
                        <Button
                            label="Cancel"
                            onClick={() => {
                                handleFinishRoute(pessangerData);
                            }}
                            type="button"
                            className="p-button p-button-danger block font-medium m-2 text-lg w-9rem"
                        />
                    </>
                ) : (
                    pessangerData?.map((passenger, index) => (
                        <div key={index} className="surface-card p-4 md:m-2">
                            <div className="flex align-items-center justify-content-between ">
                                <div className="flex align-items-center cursor-pointer">
                                    <Avatar className="profile-image border-circle cursor-pointer mr-3" image={profileImage} size="xlarge" shape="circle" />
                                    <div>
                                        <p className="mb-1 text-lg font-semibold">{passenger?.passenger?.userId?.firstName}</p>
                                        {/* <Rating value={passenger.rating} readOnly cancel={false} /> */}
                                    </div>
                                </div>
                                {/* <div className="cursor-pointer" style={{ display: "flex", gap: "10px" }}>
                                    <i className="pi pi-comments " style={{ width: "50px", height: "50px", textAlign: "center", paddingTop: "10px", borderRadius: "50px", background: "#f2882c", fontSize: "2rem" }}></i>
                                    <i className="pi pi-phone " style={{ width: "50px", height: "50px", borderRadius: "50px", paddingTop: "10px", paddingLeft: "10px", background: "blue", fontSize: "2rem" }}></i>
                                </div> */}
                            </div>
                            <hr />
                            <div className="flex align-items-center justify-content-between flex-wrap ml-2">
                                <h6 className="my-1">Date & Time</h6>
                                {/* <div className="flex align-items-center">
                    <span className="font-semibold">{passenger.date}</span>
                    <span className="mx-2 font-semibold">{passenger.startTime} -</span>
                    <span className="font-semibold">{passenger.endTime}</span>
                </div> */}
                                <span className="font-semibold">{moment(passenger?.passenger?.endTime).format("Do MMM, YYYY hh:mm A")}</span>
                            </div>
                            {/* <div className="flex my-4">
                            <div className="flex align-items-center flex-column mr-2 my-1">
                                <i className="block text-lg pi pi-circle"></i>
                                <span className="map-border-line"></span>
                                <i className="block text-lg pi pi-map-marker"></i>
                            </div>
                            <div>
                                <p className="mb-3 ml-2 font-semibold text-lg">{passenger.startLocation}</p>
                                <p className="mb-0 ml-2 font-semibold text-lg">{passenger.endLocation}</p>
                            </div>
                        </div> */}
                            <div className="flex flex-row justify-content-between mt-1">
                                <Timeline
                                    value={[
                                        { status: passenger?.passenger?.startPoint?.placeName ? passenger?.passenger?.startPoint?.placeName : "Not found", icon: "pi pi-map-marker" },
                                        { status: passenger?.passenger?.endPoint?.placeName ? passenger?.passenger?.endPoint?.placeName : "Not found", icon: "pi pi-flag" },
                                    ]}
                                    align="left"
                                    className="custom-timeline"
                                    marker={(item) => (
                                        <span className={`p-timeline-event-icon p-pt-2 text-white`}>
                                            <i className={item?.icon} style={{ fontSize: "1.5rem" }}></i>
                                        </span>
                                    )}
                                    content={(item) => (
                                        <div className="flex flex-column">
                                            <span>{item?.status}</span>
                                        </div>
                                    )}
                                />
                            </div>
                            <div className="grid lg:justify-content-between">
                                <div className="col-3 lg:col-2 xl:col-1 flex flex-column align-items-start mx-2">
                                    <p className="mb-1">Distance</p>
                                    <h6 className="my-0 font-semibold">{passenger?.passenger?.distance}</h6>
                                </div>
                                {/* <div className="col-3 lg:col-2 xl:col-1 flex flex-column align-items-start mx-2">
                                <p className="mb-1">Match</p>
                                <h6 className="my-0 font-semibold">{passenger.matchCount}</h6>
                            </div> */}
                                {/* <div className="col-3 lg:col-2 xl:col-1 flex flex-column align-items-start mx-2">
                                <p className="mb-1">Requests</p>
                                <h6 className="my-0 font-semibold">{passenger.requestCount}</h6>
                            </div> */}
                                <div className="col-3 lg:col-2 xl:col-1 flex flex-column align-items-start mx-2">
                                    <p className="mb-1">Fare</p>
                                    <h6 className="my-0 font-semibold">{passenger?.fare}</h6>
                                </div>
                                <div className="col-3 lg:col-2 xl:col-1 flex flex-column align-items-start mx-2">
                                    <p className="mb-1">Seats</p>
                                    <h6 className="my-0 font-semibold">{passenger?.passenger?.bookedSeats}</h6>
                                </div>
                            </div>

                            {passenger?.status === "pending" ? (
                                <>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <Button
                                            label="Cancel"
                                            onClick={() => {
                                                cancelReqPessanger(passenger?.passenger?._id);
                                            }}
                                            type="button"
                                            className="p-button p-button-danger block font-medium m-2 text-lg w-9rem"
                                        />
                                        <Button
                                            label={currentStatus}
                                            onClick={() => {
                                                onTheWay(passenger?.passenger?._id);
                                            }}
                                            type="button"
                                            className="block font-medium m-2 text-lg w-9rem"
                                        />
                                    </div>
                                </>
                            ) : (
                                ""
                            )}
                            {passenger?.status === "active" ? (
                                <>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <Button
                                            label="Cancel"
                                            onClick={() => {
                                                cancelReqPessanger(passenger?.passenger?._id);
                                            }}
                                            type="button"
                                            className="p-button p-button-danger block font-medium m-2 text-lg w-9rem"
                                        />
                                        <Button
                                            label={currentStatus}
                                            onClick={() => {
                                                handlearrived(passenger?.passenger?._id);
                                            }}
                                            type="button"
                                            className="block font-medium m-2 text-lg w-9rem"
                                        />
                                    </div>
                                </>
                            ) : (
                                ""
                            )}
                            {passenger?.status === "pendingPayment" ? (
                                <>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <Button
                                            label="Cancel"
                                            onClick={() => {
                                                cancelReqPessanger(passenger?.passenger?._id);
                                            }}
                                            type="button"
                                            className="p-button p-button-danger block font-medium m-2 text-lg w-9rem"
                                        />
                                        <Button
                                            label={currentStatus}
                                            onClick={() => {
                                                handlearrived(passenger?.passenger?._id);
                                            }}
                                            type="button"
                                            className="block font-medium m-2 text-lg w-9rem"
                                        />
                                    </div>
                                </>
                            ) : (
                                ""
                            )}
                            {passenger?.status === "arrived" ? (
                                <>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <Button label="Cancel" onClick={() => handleCancelClick(passenger?.passenger?._id)} type="button" className="p-button p-button-danger block font-medium m-2 text-lg w-9rem" />
                                        {/* <Button label="On the way" type="button" className="block font-medium m-2 text-lg w-9rem" /> */}
                                    </div>
                                </>
                            ) : (
                                ""
                            )}
                        </div>
                    ))
                )}
            </div>
        </>
    );
};

export default DriverRide;
